import type { Registration } from '../client';
import { isStaffRegistration } from './staffRegistrationFilter';

export type CheckInOverviewFilterOptions = {
    hideCheckedIn: boolean;
    hideUnpaid: boolean;
};

export function filterCheckInOverviewRegistrations(
    registrations: Registration[],
    options: CheckInOverviewFilterOptions,
    staffEmails: Set<string> = new Set(),
): Registration[] {
    return registrations.filter((registration) => {
        if (options.hideCheckedIn && registration.checked_in) {
            return false;
        }
        if (options.hideUnpaid) {
            const isPaidOrStaff =
                registration.paid === 'paid'
                || isStaffRegistration(registration, staffEmails);
            if (!isPaidOrStaff) {
                return false;
            }
        }
        return true;
    });
}
